import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { captureUtmFromUrl } from '../utils/utm'
import GoogleTagManager from './GoogleTagManager'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
})

// Lazy-load devtools so they are tree-shaken from the SSR/production bundle
const ReactQueryDevtools = import.meta.env.DEV
  ? (await import('@tanstack/react-query-devtools')).ReactQueryDevtools
  : () => null

export default function RootLayout() {
  // Capture utm_* params on first load and persist them in localStorage
  // so they ride along on lead-capture / register / book conversions.
  useEffect(() => {
    captureUtmFromUrl()
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <GoogleTagManager />
      <Outlet />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}
